import React, { useEffect, useState, useRef } from "react";
import {
   GetPaymentVoucherList,
   PaymentVoucherDelete,
   ApproveAccountsPaymentVoucher,
} from "../../../Services/Services";

import {
   Table,
   TableBody,
   TableCell,
   TableContainer,
   TableHead,
   TableRow,
   Paper,
   Button,
   IconButton,
   Modal,
   Box,
   TextField,
   MenuItem,
   Popover,
   Typography,
   Checkbox,
   Menu,
   Divider,
   Grid,
   Radio,
   FormControl,
   FormLabel,
   RadioGroup,
   FormControlLabel,
} from "@mui/material";

import { useMediaQuery, Collapse } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
   Edit,
   Delete,
   Print,
   Visibility,
   Add,
   Close,
   RemoveFromQueue,

} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import AddIcon from "@mui/icons-material/Add";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { generatePaymentPdf } from "./PaymentVoucherPrint";
import { generateNeftChallanPdf } from "./PaymentVoucherPrint2"
import config from "../../../config";
import { Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";

const PaymentNEFT_RTGS = () => {
   // ===== States =====
   const theme = useTheme();
   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
   const [expandedPayment, setExpandedPayment] = useState(null);
   const [PaymentVouchers, setPaymentVouchers] = useState([]);
   const [anchorEl, setAnchorEl] = useState(null);
   const [voucherToDelete, setVoucherToDelete] = useState(null);
   const [approveAnchorEl, setApproveAnchorEl] = useState(null);
   const [PaymentToApprove, setPaymentToApprove] = useState(null);
   const [remarkInput, setRemarkInput] = useState("");
   const [actionType, setActionType] = useState(null);
   const [showRemarkForIndentId, setShowRemarkForIndentId] = useState(null);
   const [page, setPage] = useState(1);
   const [hasMore, setHasMore] = useState(true);

   // 🆕 Date Range States
   const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
   const [selectingDate, setSelectingDate] = useState(null);
   const dateInputRef = useRef(null);
   const [customDateRange, setCustomDateRange] = useState({
      from: "",
      to: "",
   });

   const [filters, setFilters] = useState({
      payment_no: "",
      project_name: "",
      ledger: "",
      date_range: "today", // 🆕 Added
      payment_date: "",
      payment_mode: "Bank",
      payment_mode: "Cheque",
   });

   const navigate = useNavigate();

   // 🆕 Helper function to format date display
   const formatDateDisplay = (dateString) => {
      if (!dateString) return "";
      const [year, month, day] = dateString.split("-");
      return `${day}-${month}-${year}`;
   };

   // 🆕 Get date range display text
   const getDateRangeDisplay = (rangeType) => {
      const now = new Date();
      const formatDate = (date) => {
         const day = date.getDate().toString().padStart(2, "0");
         const month = (date.getMonth() + 1).toString().padStart(2, "0");
         const year = date.getFullYear();
         return `${day}-${month}-${year}`;
      };

      switch (rangeType) {
         case "today":
            return formatDate(now);
         case "yesterday":
            const yesterday = new Date(now);
            yesterday.setDate(yesterday.getDate() - 1);
            return formatDate(yesterday);
         case "this_week":
            const weekStart = new Date(now);
            weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1);
            return `${formatDate(weekStart)} to ${formatDate(now)}`;
         case "previous_week":
            const prevWeekEnd = new Date(now);
            prevWeekEnd.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay());
            const prevWeekStart = new Date(prevWeekEnd);
            prevWeekStart.setDate(prevWeekStart.getDate() - 6);
            return `${formatDate(prevWeekStart)} to ${formatDate(prevWeekEnd)}`;
         case "this_month":
            const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
            return `${formatDate(monthStart)} to ${formatDate(now)}`;
         case "current_year":
            const yearStart = new Date(now.getFullYear(), 0, 1);
            return `${formatDate(yearStart)} to ${formatDate(now)}`;
         case "financial_year":
            let fyStart;
            if (now.getMonth() >= 3) {
               fyStart = new Date(now.getFullYear(), 3, 1);
            } else {
               fyStart = new Date(now.getFullYear() - 1, 3, 1);
            }
            return `${formatDate(fyStart)} to ${formatDate(now)}`;
         default:
            return "";
      }
   };

   // ✅ Updated useEffect
   useEffect(() => {
      const handler = setTimeout(() => {
         setPage(1);
         fetchVouchers(1, true, filters);
      }, 500);

      return () => clearTimeout(handler);
   }, [filters, customDateRange]); // 🆕 Added customDateRange

   // ✅ Updated fetchVouchers
   const fetchVouchers = async (
      pageNum = 1,
      reset = false,
      filterValues = filters
   ) => {
      // 🆕 Build params with custom date handling
      const params = { ...filterValues };

      // Add custom dates if custom range selected
      if (filterValues.date_range === "custom" && customDateRange.from && customDateRange.to) {
         params.from_date = customDateRange.from;
         params.to_date = customDateRange.to;
      }

    

      const data = await GetPaymentVoucherList(params, pageNum);

      if (reset || pageNum === 1) {
         setPaymentVouchers(
            Array.isArray(data) ? data.results : data.results || []
         );
      } else {
         setPaymentVouchers((prev) => [
            ...prev,
            ...(Array.isArray(data) ? data.results : data.results || []),
         ]);
      }

      setHasMore(Array.isArray(data) ? data.next !== null : data.next !== null);
      setPage(pageNum);
   };

   // ✅ Updated fetchMoreData
   const fetchMoreData = () => {
      if (!hasMore) return;
      const nextPage = page + 1;
      setPage(nextPage);
      fetchVouchers(nextPage, false, filters);
   };

   const handleFilterChange = (e) => {
      const { name, value } = e.target;
      setFilters((prev) => ({ ...prev, [name]: value }));
   };

   // ✅ Updated handleReset
   const handleReset = () => {
      setFilters({
         payment_no: "",
         project_name: "",
         ledger: "",
         date_range: "today", // 🆕 Reset to today
         payment_date: "",
         payment_mode: "",
      });
      setCustomDateRange({ from: "", to: "" }); // 🆕 Reset custom dates
      setSelectingDate(null); // 🆕
      setPaymentVouchers([]);
      setPage(1);
      setHasMore(true);
   };

   const truncateText = (text, limit = 20) => {
      if (!text) return "";
      return text.length > limit ? text.substring(0, limit) + "..." : text;
   };

   const handleEditClick = async (voucher) => {
      navigate("/dashboard/payment-voucher-neft-rtgs", {
         state: {
            editMode: true,
            voucherData: voucher,
         },
      });
   };

   const handleDelete = async (voucherId) => {
      try {
         await PaymentVoucherDelete(voucherId);
         await fetchVouchers(1, true, filters);
         toast.success("Payment voucher deleted successfully!");
      } catch (error) {
         console.error("Delete error:", error);
         if (error.response?.data) {
            const errorData = error.response.data;
            if (errorData.error) {
               toast.error(errorData.error);
            } else if (typeof errorData === "string") {
               toast.error(errorData);
            } else {
               toast.error("Failed to delete payment voucher");
            }
         } else {
            toast.error("Network error. Please try again.");
         }
      }
   };

   const handleApprove = async (voucher) => {
      const approvedById = Number(localStorage.getItem("user_id"));
      if (!approvedById) {
         toast.error("Approver ID not found.");
         return;
      }

      try {
         const updated = await ApproveAccountsPaymentVoucher(
            voucher.payment_voucher_no,
            approvedById,
            voucher.status,
            remarkInput
         );

         setPaymentVouchers((prev) =>
            prev.map((item) =>
               item.payment_voucher_no == updated.payment_voucher_no ? updated : item
            )
         );

         toast.success("Payment Voucher approved successfully!");
      } catch (error) {
         console.error("Approval Error:", error);
         toast.error("Failed to approve Payment Voucher.");
      }
   };

   const userRole = localStorage.getItem("role");

   useEffect(() => {
      document.body.style.overflow = isMobile ? 'auto' : 'hidden';

      return () => {
         document.body.style.overflow = 'auto';
      };
   }, [isMobile]);

   const formatDate = (dateString) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
   };

   return (
      <>
         <ToastContainer />

         {/* Filter Section */}
         <Box sx={{ mt: -3, pt: -3, mb: 2, width: "100%" }}>
            <Grid container spacing={2} alignItems="center">
               {/* Date Range Dropdown */}
               <Grid item xs={12} sm={2.4}>
                  <TextField
                     label="Date Range"
                     value={
                        filters.date_range === "custom" &&
                           customDateRange.from &&
                           customDateRange.to
                           ? `${formatDateDisplay(
                              customDateRange.from
                           )} to ${formatDateDisplay(customDateRange.to)}`
                           : filters.date_range === "today"
                              ? "Today"
                              : filters.date_range === "yesterday"
                                 ? "Yesterday"
                                 : filters.date_range === "this_week"
                                    ? "This Week"
                                    : filters.date_range === "previous_week"
                                       ? "Previous Week"
                                       : filters.date_range === "this_month"
                                          ? "This Month"
                                          : filters.date_range === "current_year"
                                             ? "Current Year"
                                             : filters.date_range === "financial_year"
                                                ? "Financial Year"
                                                : "Select Date Range"
                     }
                     onClick={(e) => setDateMenuAnchor(e.currentTarget)}
                     size="small"
                     InputProps={{
                        readOnly: true,
                        endAdornment: (
                           <IconButton size="small" edge="end">
                              <ArrowDropDownIcon />
                           </IconButton>
                        ),
                     }}
                     sx={{
                        cursor: "pointer",
                        fontWeight: "bold",
                        "& .MuiInputBase-input": {
                           fontSize: "0.8rem",
                           padding: "4px 8px",
                        },
                        "& .MuiInputBase-root": {
                           height: 30,
                           borderRadius: 0,
                        },
                        "& .MuiInputLabel-root": {
                           fontSize: "0.6rem",
                        },
                     }}
                     fullWidth
                  />
               </Grid>

             

               {/* Project */}
               <Grid item xs={12} sm={2.4}>
                  <TextField
                     label="Project"
                     name="project_name"
                     size="small"
                     value={filters.project_name}
                     onChange={handleFilterChange}
                     sx={{
                        "& .MuiInputBase-root": {
                           height: 30,
                           borderRadius: 0,
                        },
                        "& .MuiInputLabel-root": {
                           fontSize: "0.7rem",
                        },
                     }}
                     fullWidth
                  />
               </Grid>

               {/* Ledger */}
               <Grid item xs={12} sm={2.4}>
                  <TextField
                     label="Ledger"
                     name="ledger"
                     size="small"
                     value={filters.ledger}
                     onChange={handleFilterChange}
                     sx={{
                        "& .MuiInputBase-root": {
                           height: 30,
                           borderRadius: 0,
                        },
                        "& .MuiInputLabel-root": {
                           fontSize: "0.7rem",
                        },
                     }}
                     fullWidth
                  />
               </Grid>

               {/* Payment Date */}
               <Grid item xs={12} sm={2.4}>
                  <TextField
                     label="Payment Date"
                     name="payment_date"
                     type="date"
                     value={filters.payment_date}
                     onChange={handleFilterChange}
                     size="small"
                     InputLabelProps={{ shrink: true }}
                     sx={{
                        "& .MuiInputBase-root": {
                           height: 30,
                           borderRadius: 0,
                        },
                        "& .MuiInputLabel-root": {
                           fontSize: "0.7rem",
                        },
                     }}
                     fullWidth
                  />
               </Grid>

               {/* Reset Button */}
               <Grid item xs={12} sm={1.1}>
                  <Button
                     variant="contained"
                     color="primary"
                     size="small"
                     onClick={handleReset}
                     sx={{
                        height: "30px",
                        whiteSpace: "nowrap",
                        borderRadius: "0",
                        fontSize: "0.7rem",
                     }}
                     fullWidth
                  >
                     Reset
                  </Button>
               </Grid>

               {/* Add Payment Button */}
               <Grid item xs={12} sm={1.2}>
                  <Button
                     variant="contained"
                     onClick={() => navigate("/dashboard/payment-voucher-neft-rtgs")}
                     sx={{
                        height: 30,
                        display: "flex",
                        alignItems: "center",
                        fontSize: "0.7rem",
                        borderRadius: "0",
                     }}
                     fullWidth
                  >
                     <AddIcon fontSize="small" sx={{ mr: 0.5 }} /> Payment
                  </Button>
               </Grid>
            </Grid>
         </Box>

         {/* Hidden Date Input */}
         <input
            ref={dateInputRef}
            type="date"
            style={{
               position: "absolute",
               opacity: 0,
               pointerEvents: "none",
               width: "1px",
               height: "1px",
            }}
            value={
               selectingDate === "from" ? customDateRange.from : customDateRange.to
            }
            min={selectingDate === "to" ? customDateRange.from : undefined}
            onChange={(e) => {
               const selectedDate = e.target.value;

               if (selectingDate === "from") {
                  setCustomDateRange((prev) => ({ ...prev, from: selectedDate }));
                  setSelectingDate("to");
                  setTimeout(() => {
                     dateInputRef.current?.showPicker();
                  }, 100);
               } else if (selectingDate === "to") {
                  setCustomDateRange((prev) => ({ ...prev, to: selectedDate }));
                  setFilters((prev) => ({ ...prev, date_range: "custom" }));
                  setSelectingDate(null);
                  setDateMenuAnchor(null);
               }
            }}
         />

         {/* Date Range Menu */}
         <Menu
            anchorEl={dateMenuAnchor}
            open={Boolean(dateMenuAnchor)}
            onClose={() => setDateMenuAnchor(null)}
            PaperProps={{
               sx: {
                  width: 320,
                  "& .MuiTypography-root": {
                     fontSize: "0.65rem",
                  },
               },
            }}
         >
            <MenuItem
               onClick={() => {
                  setFilters((prev) => ({ ...prev, date_range: "today" }));
                  setCustomDateRange({ from: "", to: "" });
                  setDateMenuAnchor(null);
               }}
            >
               <Box
                  sx={{
                     display: "flex",
                     justifyContent: "space-between",
                     width: "100%",
                  }}
               >
                  <Typography variant="body2">Today</Typography>
                  <Typography variant="caption" color="text.secondary">
                     {getDateRangeDisplay("today")}
                  </Typography>
               </Box>
            </MenuItem>

            <MenuItem
               onClick={() => {
                  setFilters((prev) => ({ ...prev, date_range: "yesterday" }));
                  setCustomDateRange({ from: "", to: "" });
                  setDateMenuAnchor(null);
               }}
            >
               <Box
                  sx={{
                     display: "flex",
                     justifyContent: "space-between",
                     width: "100%",
                  }}
               >
                  <Typography variant="body2">Yesterday</Typography>
                  <Typography variant="caption" color="text.secondary">
                     {getDateRangeDisplay("yesterday")}
                  </Typography>
               </Box>
            </MenuItem>

            <MenuItem
               onClick={() => {
                  setFilters((prev) => ({ ...prev, date_range: "this_week" }));
                  setCustomDateRange({ from: "", to: "" });
                  setDateMenuAnchor(null);
               }}
            >
               <Box
                  sx={{
                     display: "flex",
                     justifyContent: "space-between",
                     width: "100%",
                  }}
               >
                  <Typography variant="body2">This Week</Typography>
                  <Typography
                     variant="caption"
                     color="text.secondary"
                     sx={{ fontSize: "0.65rem" }}
                  >
                     {getDateRangeDisplay("this_week")}
                  </Typography>
               </Box>
            </MenuItem>

            <MenuItem
               onClick={() => {
                  setFilters((prev) => ({ ...prev, date_range: "previous_week" }));
                  setCustomDateRange({ from: "", to: "" });
                  setDateMenuAnchor(null);
               }}
            >
               <Box
                  sx={{
                     display: "flex",
                     justifyContent: "space-between",
                     width: "100%",
                  }}
               >
                  <Typography variant="body2">Previous Week</Typography>
                  <Typography
                     variant="caption"
                     color="text.secondary"
                     sx={{ fontSize: "0.65rem" }}
                  >
                     {getDateRangeDisplay("previous_week")}
                  </Typography>
               </Box>
            </MenuItem>

            <MenuItem
               onClick={() => {
                  setFilters((prev) => ({ ...prev, date_range: "this_month" }));
                  setCustomDateRange({ from: "", to: "" });
                  setDateMenuAnchor(null);
               }}
            >
               <Box
                  sx={{
                     display: "flex",
                     justifyContent: "space-between",
                     width: "100%",
                  }}
               >
                  <Typography variant="body2">This Month</Typography>
                  <Typography
                     variant="caption"
                     color="text.secondary"
                     sx={{ fontSize: "0.65rem" }}
                  >
                     {getDateRangeDisplay("this_month")}
                  </Typography>
               </Box>
            </MenuItem>

            <MenuItem
               onClick={() => {
                  setFilters((prev) => ({ ...prev, date_range: "current_year" }));
                  setCustomDateRange({ from: "", to: "" });
                  setDateMenuAnchor(null);
               }}
            >
               <Box
                  sx={{
                     display: "flex",
                     justifyContent: "space-between",
                     width: "100%",
                  }}
               >
                  <Typography variant="body2">Current Year</Typography>
                  <Typography
                     variant="caption"
                     color="text.secondary"
                     sx={{ fontSize: "0.65rem" }}
                  >
                     {getDateRangeDisplay("current_year")}
                  </Typography>
               </Box>
            </MenuItem>

            <MenuItem
               onClick={() => {
                  setFilters((prev) => ({ ...prev, date_range: "financial_year" }));
                  setCustomDateRange({ from: "", to: "" });
                  setDateMenuAnchor(null);
               }}
            >
               <Box
                  sx={{
                     display: "flex",
                     justifyContent: "space-between",
                     width: "100%",
                  }}
               >
                  <Typography variant="body2">Financial Year</Typography>
                  <Typography
                     variant="caption"
                     color="text.secondary"
                     sx={{ fontSize: "0.65rem" }}
                  >
                     {getDateRangeDisplay("financial_year")}
                  </Typography>
               </Box>
            </MenuItem>

            <Divider />

            <MenuItem
               onClick={() => {
                  setDateMenuAnchor(null);
                  setSelectingDate("from");
                  setTimeout(() => {
                     dateInputRef.current?.showPicker();
                  }, 100);
               }}
            >
               <Typography variant="body2">Custom Date Range</Typography>
            </MenuItem>
         </Menu>

         {/* InfiniteScroll with Mobile/Desktop Views */}
         <InfiniteScroll
            dataLength={PaymentVouchers.length}
            next={fetchMoreData}
            hasMore={hasMore}
            scrollableTarget={isMobile ? undefined : "scrollableDiv"}
            loader={<h4>Loading...</h4>}
         >
            {isMobile ? (
               /* 📱 MOBILE VIEW */
               <Box
                  sx={{
                     bgcolor: "background.paper",
                     // maxHeight: "88vh",
                     overflow: "auto",
                  }}
               >
                  {PaymentVouchers.map((voucher, index) => (
                     <Box key={voucher.id || index}>
                        <Box
                           onClick={() =>
                              setExpandedPayment(
                                 expandedPayment === voucher.payment_voucher_no
                                    ? null
                                    : voucher.payment_voucher_no
                              )
                           }
                           sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              p: 1.5,
                              cursor: "pointer",
                              bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                              "&:active": {
                                 bgcolor: "#e3f2fd",
                              },
                              borderLeft: `4px solid ${voucher.status === "Approved"
                                 ? "#4caf50"
                                 : voucher.status === "Rejected"
                                    ? "#f44336"
                                    : "#ff9800"
                                 }`,
                           }}
                        >
                           <Box sx={{ flex: 1 }}>
                              <Box
                                 sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                    mb: 0.5,
                                 }}
                              >
                                 <Typography
                                    sx={{
                                       fontSize: "0.7rem",
                                       color: "#666",
                                       minWidth: 25,
                                    }}
                                 >
                                    #{index + 1}
                                 </Typography>
                                 <Typography
                                    sx={{
                                       fontWeight: "bold",
                                       fontSize: "0.85rem",
                                       flex: 1,
                                    }}
                                 >
                                    {voucher.payment_number}
                                 </Typography>
                              </Box>

                              <Box
                                 sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 1,
                                 }}
                              >
                                 <Typography
                                    sx={{
                                       fontSize: "0.75rem",
                                       fontWeight: 600,
                                       color: "#1976d2",
                                    }}
                                 >
                                    ₹
                                    {Number(voucher.total_amount || 0).toLocaleString(
                                       "en-IN"
                                    )}
                                 </Typography>
                                 <Chip
                                    label={voucher.payment_mode}
                                    color="primary"
                                    size="small"
                                    sx={{
                                       height: "10px",
                                       transform: "scale(0.8)",
                                       "& .MuiChip-label": {
                                          padding: "0 6px",
                                       },
                                    }}
                                 />
                              </Box>
                           </Box>

                           <IconButton size="small" sx={{ ml: 1 }}>
                              {expandedPayment === voucher.payment_voucher_no ? (
                                 <ExpandLess fontSize="small" />
                              ) : (
                                 <ExpandMore fontSize="small" />
                              )}
                           </IconButton>
                        </Box>

                        <Collapse
                           in={expandedPayment === voucher.payment_voucher_no}
                           timeout="auto"
                           unmountOnExit
                        >
                           <Box
                              sx={{
                                 px: 1.5,
                                 py: 1,
                                 bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
                                 borderLeft: `4px solid ${voucher.status === "Approved"
                                    ? "#4caf50"
                                    : voucher.status === "Rejected"
                                       ? "#f44336"
                                       : "#ff9800"
                                    }`,
                              }}
                           >
                              {/* Amount Box */}
                              <Box
                                 sx={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr",
                                    gap: 0.8,
                                    mb: 1,
                                    p: 1,
                                    bgcolor: "#e3f2fd",
                                    borderRadius: "4px",
                                 }}
                              >
                                 <Box>
                                    <Typography
                                       sx={{
                                          fontSize: "0.6rem",
                                          color: "#1976d2",
                                          letterSpacing: "0.5px",
                                       }}
                                    >
                                       PAID AMOUNT
                                    </Typography>
                                    <Typography
                                       sx={{
                                          fontSize: "0.85rem",
                                          fontWeight: 600,
                                          color: "#1976d2",
                                       }}
                                    >
                                       ₹
                                       {Number(voucher.total_amount || 0).toLocaleString(
                                          "en-IN"
                                       )}
                                    </Typography>
                                 </Box>
                              </Box>

                              {/* Details Grid */}
                              <Box
                                 sx={{
                                    display: "grid",
                                    gridTemplateColumns: "1fr 1fr",
                                    gap: 0.8,
                                    mb: 1,
                                 }}
                              >
                                 <Box sx={{ gridColumn: "1 / -1" }}>
                                    <Typography
                                       sx={{
                                          fontSize: "0.6rem",
                                          color: "#999",
                                          letterSpacing: "0.5px",
                                       }}
                                    >
                                       LEDGER NAME
                                    </Typography>
                                    <Typography
                                       sx={{
                                          fontSize: "0.75rem",
                                          fontWeight: 500,
                                          color: "#333",
                                       }}
                                    >
                                       {voucher.supplier_name ||
                                          voucher.expense_name ||
                                          voucher.advanceworker_name ||
                                          voucher.imprest_name ||
                                          voucher.party_name ||
                                          voucher.transporter_name ||
                                          "N/A"}
                                    </Typography>
                                 </Box>

                                 <Box sx={{ gridColumn: "1 / -1" }}>
                                    <Typography
                                       sx={{
                                          fontSize: "0.6rem",
                                          color: "#999",
                                          letterSpacing: "0.5px",
                                       }}
                                    >
                                       PROJECT
                                    </Typography>
                                    <Typography
                                       sx={{
                                          fontSize: "0.75rem",
                                          fontWeight: 500,
                                          color: "#333",
                                       }}
                                    >
                                       {voucher.project_name || "N/A"}
                                    </Typography>
                                 </Box>

                                 <Box>
                                    <Typography
                                       sx={{
                                          fontSize: "0.6rem",
                                          color: "#999",
                                          letterSpacing: "0.5px",
                                       }}
                                    >
                                       DIVISION
                                    </Typography>
                                    <Typography
                                       sx={{
                                          fontSize: "0.72rem",
                                          fontWeight: 500,
                                          color: "#555",
                                       }}
                                    >
                                       {voucher.division_name || "N/A"}
                                    </Typography>
                                 </Box>

                                 <Box>
                                    <Typography
                                       sx={{
                                          fontSize: "0.6rem",
                                          color: "#999",
                                          letterSpacing: "0.5px",
                                       }}
                                    >
                                       PAYMENT MODE
                                    </Typography>
                                    <Typography
                                       sx={{
                                          fontSize: "0.72rem",
                                          fontWeight: 500,
                                          color: "#555",
                                       }}
                                    >
                                       {voucher.payment_mode || "N/A"}
                                    </Typography>
                                 </Box>

                                 <Box>
                                    <Typography
                                       sx={{
                                          fontSize: "0.6rem",
                                          color: "#999",
                                          letterSpacing: "0.5px",
                                       }}
                                    >
                                       PAYMENT DATE
                                    </Typography>
                                    <Typography
                                       sx={{
                                          fontSize: "0.72rem",
                                          fontWeight: 500,
                                          color: "#555",
                                       }}
                                    >
                                       {voucher.payment_date || "N/A"}
                                    </Typography>
                                 </Box>

                                 <Box>
                                    <Typography
                                       sx={{
                                          fontSize: "0.6rem",
                                          color: "#999",
                                          letterSpacing: "0.5px",
                                       }}
                                    >
                                       DATE
                                    </Typography>
                                    <Typography
                                       sx={{
                                          fontSize: "0.72rem",
                                          fontWeight: 500,
                                          color: "#555",
                                       }}
                                    >
                                       {formatDate(voucher.created_at)}
                                    </Typography>
                                 </Box>

                                 <Box>
                                    <Typography
                                       sx={{
                                          fontSize: "0.6rem",
                                          color: "#999",
                                          letterSpacing: "0.5px",
                                       }}
                                    >
                                       CREATED BY
                                    </Typography>
                                    <Typography
                                       sx={{
                                          fontSize: "0.72rem",
                                          fontWeight: 500,
                                          color: "#555",
                                       }}
                                    >
                                       {voucher.created_by_name || "N/A"}
                                    </Typography>
                                 </Box>

                                 {voucher.approved_name && (
                                    <Box>
                                       <Typography
                                          sx={{
                                             fontSize: "0.6rem",
                                             color: "#999",
                                             letterSpacing: "0.5px",
                                          }}
                                       >
                                          APPROVED BY
                                       </Typography>
                                       <Typography
                                          sx={{
                                             fontSize: "0.72rem",
                                             fontWeight: 500,
                                             color: "#555",
                                          }}
                                       >
                                          {voucher.approved_name}
                                       </Typography>
                                    </Box>
                                 )}
                              </Box>

                              {voucher.remarks && (
                                 <Box sx={{ mb: 0.8 }}>
                                    <Typography
                                       sx={{
                                          fontSize: "0.6rem",
                                          color: "#999",
                                          letterSpacing: "0.5px",
                                          mb: 0.3,
                                       }}
                                    >
                                       REMARKS
                                    </Typography>
                                    <Typography
                                       sx={{
                                          fontSize: "0.7rem",
                                          color: "#555",
                                          fontStyle: "italic",
                                          lineHeight: 1.3,
                                       }}
                                    >
                                       {voucher.remarks}
                                    </Typography>
                                 </Box>
                              )}

                              <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                              <Box
                                 sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: 1,
                                 }}
                              >
                                 {userRole != "Staff" && (
                                    <Box
                                       sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 0.5,
                                          bgcolor:
                                             voucher.status === "Approved"
                                                ? "#e8f5e9"
                                                : voucher.status === "Rejected"
                                                   ? "#ffebee"
                                                   : "#fff3e0",
                                          px: 1,
                                          py: 0.5,
                                          borderRadius: "6px",
                                          border: `1px solid ${voucher.status === "Approved"
                                             ? "#4caf50"
                                             : voucher.status === "Rejected"
                                                ? "#f44336"
                                                : "#ff9800"
                                             }`,
                                       }}
                                    >
                                       <Checkbox
                                          checked={
                                             voucher.status === "Approved" ||
                                             voucher.status === "Rejected"
                                          }
                                          onChange={(e) => {
                                             e.stopPropagation();
                                             setApproveAnchorEl(e.currentTarget);
                                             setPaymentToApprove(voucher);
                                          }}
                                          sx={{
                                             padding: 0,
                                             transform: "scale(0.75)",
                                             color:
                                                voucher.status === "Approved"
                                                   ? "#4caf50"
                                                   : voucher.status === "Rejected"
                                                      ? "#f44336"
                                                      : "#ff9800",
                                             "&.Mui-checked": {
                                                color:
                                                   voucher.status === "Approved"
                                                      ? "#4caf50"
                                                      : "#f44336",
                                             },
                                          }}
                                       />
                                       <Typography
                                          sx={{
                                             fontSize: "0.7rem",
                                             fontWeight: 600,
                                             color:
                                                voucher.status === "Approved"
                                                   ? "#2e7d32"
                                                   : voucher.status === "Rejected"
                                                      ? "#c62828"
                                                      : "#f57c00",
                                          }}
                                       >
                                          {voucher.status === "Approved"
                                             ? "Approved"
                                             : voucher.status === "Rejected"
                                                ? "Rejected"
                                                : "Approve"}
                                       </Typography>
                                    </Box>
                                 )}

                                 <Box sx={{ display: "flex", gap: 0.6 }}>
                                    <IconButton
                                       size="small"
                                       onClick={(e) => {
                                          e.stopPropagation();
                                          handleEditClick(voucher);
                                       }}
                                       disabled={voucher.status === "Approved"}
                                       sx={{
                                          bgcolor: "#e3f2fd",
                                          borderRadius: "6px",
                                          width: 32,
                                          height: 32,
                                          "&:hover": {
                                             bgcolor: "#bbdefb",
                                             transform: "scale(1.05)",
                                          },
                                          "&:disabled": {
                                             bgcolor: "#f5f5f5",
                                             opacity: 0.5,
                                          },
                                          transition: "all 0.2s",
                                       }}
                                    >
                                       <Edit
                                          sx={{
                                             fontSize: "1rem",
                                             color: "#1976d2",
                                             transform: "scale(0.6)",
                                          }}
                                       />
                                    </IconButton>

                                    <IconButton
                                       size="small"
                                       onClick={(e) => {
                                          e.stopPropagation();
                                          setAnchorEl(e.currentTarget);
                                          setVoucherToDelete(voucher.payment_voucher_no);
                                       }}
                                       disabled={voucher.status === "Approved"}
                                       sx={{
                                          bgcolor: "#ffebee",
                                          borderRadius: "6px",
                                          width: 32,
                                          height: 32,
                                          "&:hover": {
                                             bgcolor: "#ffcdd2",
                                             transform: "scale(1.05)",
                                          },
                                          "&:disabled": {
                                             bgcolor: "#f5f5f5",
                                             opacity: 0.5,
                                          },
                                          transition: "all 0.2s",
                                       }}
                                    >
                                       <Delete
                                          sx={{
                                             fontSize: "1rem",
                                             color: "#d32f2f",
                                             transform: "scale(0.6)",
                                          }}
                                       />
                                    </IconButton>

                                    <IconButton
                                       size="small"
                                       onClick={(e) => {
                                          e.stopPropagation();
                                          generatePaymentPdf(voucher);
                                       }}
                                       sx={{
                                          bgcolor: "#fff3e0",
                                          borderRadius: "6px",
                                          width: 32,
                                          height: 32,
                                          "&:hover": {
                                             bgcolor: "#ffe0b2",
                                             transform: "scale(1.05)",
                                          },
                                          transition: "all 0.2s",
                                       }}
                                    >
                                       <Print
                                          sx={{
                                             fontSize: "1rem",
                                             color: "#f57c00",
                                             transform: "scale(0.6)",
                                          }}
                                       />
                                    </IconButton>

                                    {typeof voucher.attachment === "string" ? (
                                       <a
                                          href={`${voucher.attachment}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          onClick={(e) => e.stopPropagation()}
                                       >
                                          <IconButton
                                             size="small"
                                             sx={{
                                                bgcolor: "#e8f5e9",
                                                borderRadius: "6px",
                                                width: 32,
                                                height: 32,
                                                "&:hover": {
                                                   bgcolor: "#c8e6c9",
                                                   transform: "scale(1.05)",
                                                },
                                                transition: "all 0.2s",
                                             }}
                                          >
                                             <Visibility
                                                sx={{
                                                   fontSize: "1rem",
                                                   color: "#2e7d32",
                                                   transform: "scale(0.6)",
                                                }}
                                             />
                                          </IconButton>
                                       </a>
                                    ) : voucher.attachment instanceof File ? (
                                       <a
                                          href={URL.createObjectURL(voucher.attachment)}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          onClick={(e) => e.stopPropagation()}
                                       >
                                          <IconButton
                                             size="small"
                                             sx={{
                                                bgcolor: "#e8f5e9",
                                                borderRadius: "6px",
                                                width: 32,
                                                height: 32,
                                                "&:hover": {
                                                   bgcolor: "#c8e6c9",
                                                   transform: "scale(1.05)",
                                                },
                                                transition: "all 0.2s",
                                             }}
                                          >
                                             <Visibility
                                                sx={{
                                                   fontSize: "1rem",
                                                   color: "#2e7d32",
                                                   transform: "scale(0.6)",
                                                }}
                                             />
                                          </IconButton>
                                       </a>
                                    ) : null}
                                 </Box>
                              </Box>
                           </Box>
                        </Collapse>

                        <Divider />
                     </Box>
                  ))}

                  {/* Mobile Total Summary */}
                  <Box
                     sx={{
                        p: 2,
                        bgcolor: "#e3f2fd",
                        position: "sticky",
                        bottom: 0,
                        borderTop: "2px solid #1976d2",
                     }}
                  >
                     <Box
                        sx={{
                           display: "flex",
                           justifyContent: "space-between",
                        }}
                     >
                        <Typography
                           sx={{
                              fontSize: "0.75rem",
                              fontWeight: "bold",
                              color: "#1976d2",
                           }}
                        >
                           Total Amount:
                        </Typography>
                        <Typography
                           sx={{
                              fontSize: "0.75rem",
                              fontWeight: "bold",
                              color: "#1976d2",
                           }}
                        >
                           ₹
                           {PaymentVouchers.reduce(
                              (sum, v) => sum + parseFloat(v.total_amount || 0),
                              0
                           ).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                           })}
                        </Typography>
                     </Box>
                  </Box>
               </Box>
            ) : (
               /* 💻 DESKTOP VIEW */
               <TableContainer
                  component={Paper}
                  id="scrollableDiv"
                  sx={{
                     maxHeight: "88vh",
                     overflow: "auto",
                  }}
               >
                  <Table
                     stickyHeader
                     size="small"
                     sx={{
                        minWidth: 1600,
                        "& td, & th": {
                           textAlign: "center",
                           whiteSpace: "nowrap",
                           backgroundColor: "#f5f5f5",
                           borderBottom: "1px solid #ccc",
                        },
                     }}
                  >
                     <TableHead>
                        <TableRow
                           sx={{
                              backgroundColor: "#f5f5f5",
                              "& th": {
                                 fontWeight: "bold",
                                 color: "#333",
                                 borderBottom: "1px solid #999",
                                 whiteSpace: "nowrap",
                                 fontSize: "0.75rem",
                              },
                           }}
                        >
                           {userRole != "Staff" && (
                              <TableCell
                                 sx={{
                                    position: "sticky",
                                    left: 0,
                                    backgroundColor: "#fafafa",
                                    zIndex: 3,
                                 }}
                              >
                                 Approve
                              </TableCell>
                           )}
                           <TableCell
                              sx={{
                                 position: "sticky",
                                 left: userRole != "Staff" ? 80 : 0,
                                 backgroundColor: "#f5f5f5",
                                 zIndex: 3,
                              }}
                           >
                              S.No.
                           </TableCell>

                           <TableCell>Voucher No</TableCell>
                           <TableCell>Status</TableCell>
                           <TableCell>Ledger Name</TableCell>
                           <TableCell>Project</TableCell>
                           <TableCell>Division</TableCell>
                           <TableCell>Paid Amt</TableCell>
                           <TableCell>Payment Mode</TableCell>
                           <TableCell>Payment Date</TableCell>
                           <TableCell>Date</TableCell>
                           <TableCell>Created By</TableCell>
                           <TableCell>Approved By</TableCell>
                           <TableCell>Remarks</TableCell>
                           <TableCell
                              align="center"
                              sx={{
                                 position: "sticky",
                                 right: 0,
                                 backgroundColor: "#f5f5f5",
                                 zIndex: 3,
                              }}
                           >
                              Action
                           </TableCell>
                        </TableRow>
                     </TableHead>

                     <TableBody>
                        {PaymentVouchers.map((voucher, index) => (
                           <TableRow
                              hover
                              key={index}
                              sx={{
                                 backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                                 "&:hover": {
                                    backgroundColor: "#e3f2fd",
                                    "& td": {
                                       backgroundColor: "#e3f2fd !important",
                                    },
                                 },
                                 "& td": {
                                    paddingRight: "13px !important",
                                    paddingLeft: "13px !important",
                                    padding: "0px",
                                    fontSize: { xs: "0.65rem", sm: "0.75rem" },
                                    whiteSpace: "nowrap",
                                    color: (theme) =>
                                       theme.palette.mode === "dark" ? "white" : "inherit",
                                    backgroundColor: (theme) =>
                                       theme.palette.mode === "dark" ? "black" : "inherit",
                                 },
                              }}
                           >
                              {userRole != "Staff" && (
                                 <TableCell
                                    sx={{
                                       position: "sticky",
                                       left: 0,
                                       backgroundColor: "#fafafa",
                                       zIndex: 2,
                                    }}
                                 >
                                    <Checkbox
                                       checked={
                                          voucher.status === "Approved" ||
                                          voucher.status === "Rejected"
                                       }
                                       onChange={(e) => {
                                          setApproveAnchorEl(e.currentTarget);
                                          setPaymentToApprove(voucher);
                                       }}
                                       sx={{
                                          padding: 0,
                                          paddingLeft: 1,
                                          paddingRight: 1,
                                          transform: "scale(0.6)",
                                          color:
                                             voucher.status === "Approved"
                                                ? "green"
                                                : voucher.status === "Rejected"
                                                   ? "red"
                                                   : "grey",
                                          "&.Mui-checked": {
                                             color:
                                                voucher.status === "Approved"
                                                   ? "green"
                                                   : "red",
                                          },
                                       }}
                                    />
                                 </TableCell>
                              )}
                              <TableCell
                                 sx={{
                                    position: "sticky",
                                    left: userRole != "Staff" ? 80 : 0,
                                    backgroundColor: "#f5f5f5",
                                    zIndex: 2,
                                 }}
                              >
                                 {index + 1}
                              </TableCell>

                              <TableCell>{voucher.payment_number}</TableCell>

                              <TableCell align="center">
                                 <Chip
                                    label={
                                       voucher.status === "Approved"
                                          ? "Approved"
                                          : voucher.status === "Rejected"
                                             ? "Rejected"
                                             : "Pending"
                                    }
                                    color={
                                       voucher.status === "Approved"
                                          ? "success"
                                          : voucher.status === "Rejected"
                                             ? "error"
                                             : "warning"
                                    }
                                    variant="outlined"
                                    size="small"
                                    sx={{
                                       height: "10px",
                                       transform: "scale(0.8)",
                                       "& .MuiChip-label": {
                                          padding: "0 6px",
                                       },
                                    }}
                                 />
                              </TableCell>
                              <TableCell>
                                 {voucher.supplier_name ||
                                    voucher.expense_name ||
                                    voucher.advanceworker_name ||
                                    voucher.imprest_name ||
                                    voucher.party_name ||
                                    voucher.transporter_name}
                              </TableCell>

                              <TableCell>{voucher.project_name}</TableCell>
                              <TableCell>{voucher.division_name}</TableCell>

                              <TableCell>
                                 {Number(voucher.total_amount || 0).toLocaleString(
                                    "en-IN"
                                 )}
                              </TableCell>

                              <TableCell>{voucher.payment_mode}</TableCell>
                              <TableCell>{voucher.payment_date}</TableCell>
                              <TableCell>{formatDate(voucher.created_at)}</TableCell>
                              <TableCell>{voucher.created_by_name}</TableCell>
                              <TableCell>{voucher.approved_name}</TableCell>
                              <TableCell>
                                 <Tooltip title={voucher.remarks || ""} arrow>
                                    <span>{truncateText(voucher.remarks || "", 20)}</span>
                                 </Tooltip>
                              </TableCell>
                              <TableCell
                                 sx={{
                                    position: "sticky",
                                    right: 0,
                                    backgroundColor: "#f5f5f5",
                                    zIndex: 2,
                                    minWidth: 180,
                                 }}
                              >
                                 <Box
                                    sx={{
                                       display: "flex",
                                       justifyContent: "center",
                                       alignItems: "center",
                                       gap: 0.5,
                                    }}
                                 >
                                    <IconButton
                                       size="small"
                                       color="primary"
                                       onClick={() => handleEditClick(voucher)}
                                       disabled={voucher.status === "Approved"}
                                       sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                                    >
                                       <Edit transform="scale(0.6)" />
                                    </IconButton>

                                    <IconButton
                                       size="small"
                                       color="error"
                                       onClick={(e) => {
                                          setAnchorEl(e.currentTarget);
                                          setVoucherToDelete(voucher.payment_voucher_no);
                                       }}
                                       disabled={voucher.status === "Approved"}
                                       sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                                    >
                                       <Delete transform="scale(0.6)" />
                                    </IconButton>
{/* 
                                    <IconButton
                                       sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                                       color="warning"
                                       size="small"
                                       onClick={() => generatePaymentPdf(voucher)}
                                    >
                                       <Print transform="scale(0.6)" />
                                    </IconButton> */}

                                    <IconButton
                                       sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                                       color="primary"
                                       size="small"
                                       onClick={() => generateNeftChallanPdf(voucher)}
                                    >
                                       <Print transform="scale(0.6)" />
                                    </IconButton>
                                    {typeof voucher.attachment === "string" ? (
                                       <a
                                          href={`${voucher.attachment}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                       >
                                          <IconButton
                                             sx={{
                                                padding: 0,
                                                paddingLeft: 1,
                                                paddingRight: 1,
                                             }}
                                             color="info"
                                             size="small"
                                          >
                                             <Visibility transform="scale(0.6)" />
                                          </IconButton>
                                       </a>
                                    ) : voucher.attachment instanceof File ? (
                                       <a
                                          href={URL.createObjectURL(voucher.attachment)}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                       >
                                          <IconButton
                                             sx={{
                                                padding: 0,
                                                paddingLeft: 1,
                                                paddingRight: 1,
                                             }}
                                             color="info"
                                             size="small"
                                          >
                                             <Visibility fontSize="small" />
                                          </IconButton>
                                       </a>
                                    ) : (
                                       <span
                                          style={{ display: "inline-block", width: 30 }}
                                       />
                                    )}
                                 </Box>
                              </TableCell>
                           </TableRow>
                        ))}
                        <TableRow
                           sx={{
                              "& td": {
                                 backgroundColor: "#E3F2FD !important",
                                 color: "#000 !important",
                                 fontWeight: "bold !important",
                              },
                           }}
                        >
                           <TableCell colSpan={7} align="right">
                              Totals:
                           </TableCell>
                           <TableCell>
                              {PaymentVouchers.reduce(
                                 (sum, v) => sum + parseFloat(v.total_amount || 0),
                                 0
                              ).toLocaleString("en-IN", {
                                 minimumFractionDigits: 2,
                                 maximumFractionDigits: 2,
                              })}
                           </TableCell>
                           <TableCell colSpan={7}></TableCell>
                        </TableRow>
                     </TableBody>
                  </Table>
               </TableContainer>
            )}
         </InfiniteScroll>

         {/* Delete Popover */}
         <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={() => {
               setAnchorEl(null);
               setVoucherToDelete(null);
            }}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
         >
            <Box sx={{ p: 2 }}>
               <Typography variant="body2">Are you sure?</Typography>
               <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                  <Button
                     color="error"
                     size="small"
                     onClick={async () => {
                        await handleDelete(voucherToDelete);
                        setAnchorEl(null);
                        setVoucherToDelete(null);
                     }}
                  >
                     Yes
                  </Button>
                  <Button
                     size="small"
                     onClick={() => {
                        setAnchorEl(null);
                        setVoucherToDelete(null);
                     }}
                  >
                     No
                  </Button>
               </Box>
            </Box>
         </Popover>

         {/* Approve Popover */}
         <Popover
            open={Boolean(approveAnchorEl)}
            anchorEl={approveAnchorEl}
            onClose={() => {
               setApproveAnchorEl(null);
               setPaymentToApprove(null);
               setRemarkInput("");
               setShowRemarkForIndentId(null);
               setActionType(null);
            }}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
         >
            <Box sx={{ p: 2, minWidth: 250 }}>
               {showRemarkForIndentId === PaymentToApprove?.payment_voucher_no ? (
                  <>
                     <Typography variant="body2" sx={{ mb: 1 }}>
                        Please enter remark before{" "}
                        {actionType === "Approved" ? "approving" : "rejecting"}:
                     </Typography>
                     <TextField
                        fullWidth
                        size="small"
                        value={remarkInput}
                        onChange={(e) => setRemarkInput(e.target.value)}
                        placeholder="Enter remark"
                     />

                     <Box
                        sx={{
                           display: "flex",
                           justifyContent: "space-between",
                           mt: 2,
                        }}
                     >
                        <Button
                           color={actionType === "Approved" ? "success" : "error"}
                           size="small"
                           onClick={() => {
                              if (!remarkInput.trim()) {
                                 toast.error("Remark is required!");
                                 return;
                              }
                              handleApprove({
                                 ...PaymentToApprove,
                                 status: actionType,
                                 remarks: remarkInput,
                              });
                              setApproveAnchorEl(null);
                              setPaymentToApprove(null);
                              setRemarkInput("");
                              setShowRemarkForIndentId(null);
                              setActionType(null);
                           }}
                        >
                           Yes
                        </Button>
                        <Button
                           size="small"
                           onClick={() => {
                              setApproveAnchorEl(null);
                              setPaymentToApprove(null);
                              setRemarkInput("");
                              setShowRemarkForIndentId(null);
                              setActionType(null);
                           }}
                        >
                           No
                        </Button>
                     </Box>
                  </>
               ) : (
                  <>
                     <Typography variant="body2" sx={{ mb: 1 }}>
                        Do you want to approve or reject this Payment Voucher?
                     </Typography>

                     <Box
                        sx={{
                           display: "flex",
                           justifyContent: "space-between",
                           mt: 2,
                        }}
                     >
                        <Button
                           color="success"
                           size="small"
                           onClick={() => {
                              setShowRemarkForIndentId(
                                 PaymentToApprove?.payment_voucher_no
                              );
                              setActionType("Approved");
                           }}
                        >
                           Approve
                        </Button>
                        <Button
                           color="error"
                           size="small"
                           onClick={() => {
                              setShowRemarkForIndentId(
                                 PaymentToApprove?.payment_voucher_no
                              );
                              setActionType("Rejected");
                           }}
                        >
                           Reject
                        </Button>
                     </Box>
                  </>
               )}
            </Box>
         </Popover>
      </>
   );

};

export default PaymentNEFT_RTGS;
